export const ENDPOINTS = {
  getHotelInfo: '/gateway/extranet/:id/hotel',
  getHotels: '/gateway/extranet/hotels',
  getHotelPacks: '/gateway/extranet/:id/packs',
  getHotelExperiences: '/gateway/extranet/:id/experiences',
  getHotelRooms: '/gateway/extranet/:id/rooms',
  getHotelFinance: '/gateway/extranet/hotels/:id/finance',
  saveHotelFinance: '/gateway/extranet/hotels/:id/finance',
  getHotelContacts: '/gateway/extranet/:id/contacts',
  updateHotelContacts: '/gateway/extranet/:id/contacts',
} as const;

export const CORE_QUERY_KEYS = {
  hotelInfo: 'extranet-hotel-info',
  hotels: 'extranet-hotels',
  hotelPacks: 'extranet-hotel-packs',
  hotelExperiences: 'extranet-hotel-experiences',
  hotelRooms: 'extranet-hotel-rooms',
  hotelFinance: 'extranet-hotel-finance',
  hotelContacts: 'extranet-hotel-contacts',
} as const;
